import SuperFetchV2 from '../../superFetchV2';
import {
  PaymentSettingLogsFindResponse,
  PaymentSettingLogsParams,
  PgProviderRoutesFindResponse,
  PgProviderRoutesUpdateRequest,
  PgProviderRoutesUpdateResponse,
} from './types';

const BASE = '/pg-provider-routes';
const requestOptions = { skipFullscreenLoader: true, skipErrorModal: true };

export const pgProviderRouteApi = {
  getRoutes: (): Promise<PgProviderRoutesFindResponse> =>
    SuperFetchV2.get<unknown, PgProviderRoutesFindResponse>(BASE, requestOptions),
  getLogs: (params: PaymentSettingLogsParams = {}): Promise<PaymentSettingLogsFindResponse> =>
    SuperFetchV2.get<unknown, PaymentSettingLogsFindResponse>(BASE + '/logs', { ...requestOptions, params }),
  updateRoutes: (body: PgProviderRoutesUpdateRequest): Promise<PgProviderRoutesUpdateResponse> =>
    SuperFetchV2.put<unknown, PgProviderRoutesUpdateResponse>(BASE, body, requestOptions),
};
